import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = (props) => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return <>{props.children}</>;
};
window.onbeforeunload = function () {
  window.scrollTo(0, 0);
};

export default ScrollToTop;
